import { render, staticRenderFns } from "./tags-usage-report.vue?vue&type=template&id=24ad170e&scoped=true"
import script from "./tags-usage-report.vue?vue&type=script&lang=js"
export * from "./tags-usage-report.vue?vue&type=script&lang=js"
import style0 from "./tags-usage-report.vue?vue&type=style&index=0&id=24ad170e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24ad170e",
  null
  
)

export default component.exports